export default __webpack_public_path__ + "media/images/features/yado/left_loop-66e614040e1b8085933d984786815cb8.png";